// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_country from "../../commonapis/gen/buhta_common_v1_country.js";
import * as Buhta_commonapis__Buhta_common_v1_grid from "../../commonapis/gen/buhta_common_v1_grid.js";
import * as Buhta_commonapis__Buhta_common_v1_org_type from "../../commonapis/gen/buhta_common_v1_org_type.js";
import * as Buhta_controlapis__Buhta_control_v1alpha1_org from "./buhta_control_v1alpha1_org.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_type__Google_type_date from "../../third_party/google_type/gen/google_type_date.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const GetOrgRequest = Caml_module.init_mod([
  "proto/controlapis/gen/buhta_control_v1alpha1_org_service.ml",
  1211,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const GetOrgResponse = Caml_module.init_mod([
  "proto/controlapis/gen/buhta_control_v1alpha1_org_service.ml",
  1274,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const ListOrgsRequest = Caml_module.init_mod([
  "proto/controlapis/gen/buhta_control_v1alpha1_org_service.ml",
  1334,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const ListOrgsResponse = Caml_module.init_mod([
  "proto/controlapis/gen/buhta_control_v1alpha1_org_service.ml",
  1394,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const LookupOrgRequest = Caml_module.init_mod([
  "proto/controlapis/gen/buhta_control_v1alpha1_org_service.ml",
  1455,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const LookupOrgResponse = Caml_module.init_mod([
  "proto/controlapis/gen/buhta_control_v1alpha1_org_service.ml",
  1518,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const CreateOrgRequest = Caml_module.init_mod([
  "proto/controlapis/gen/buhta_control_v1alpha1_org_service.ml",
  1578,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const CreateOrgResponse = Caml_module.init_mod([
  "proto/controlapis/gen/buhta_control_v1alpha1_org_service.ml",
  1638,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const OrgData = Caml_module.init_mod([
  "proto/controlapis/gen/buhta_control_v1alpha1_org_service.ml",
  1752,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "BankAccount"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name(param) {
  return ".buhta.control.v1alpha1.GetOrgRequest";
}

function make(idOpt, expandOpt, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  const expand = expandOpt !== undefined ? expandOpt : /* [] */ 0;
  return {
    id: id,
    expand: expand
  };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

const merge_expand = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    2,
    "expand",
    "expand"
  ],
  Ocaml_protoc_plugin__Spec.string,
  Ocaml_protoc_plugin__Spec.not_packed
]));

function merge(t1, t2) {
  return {
    id: Curry._2(merge_id, t1.id, t2.id),
    expand: Curry._2(merge_expand, t1.expand, t2.expand)
  };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      2,
      "expand",
      "expand"
    ],
    Ocaml_protoc_plugin__Spec.string,
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
});

function to_proto$p(writer, param) {
  Curry._3(serialize, writer, param.id, param.expand);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(id, expand) {
  return {
    id: id,
    expand: expand
  };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
});

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn, writer);
  });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.GetOrgRequest", spec(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.expand);
  };
}

function constructor$1(id, expand) {
  return {
    id: id,
    expand: expand
  };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.GetOrgRequest", spec(undefined), constructor$1);
});

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, GetOrgRequest, {
  make: make,
  to_proto: to_proto,
  from_proto: from_proto,
  to_json: to_json,
  from_json: from_json,
  name: name,
  merge: merge,
  to_proto$p: to_proto$p,
  from_proto_exn: from_proto_exn,
  from_json_exn: from_json_exn
});

function name$1(param) {
  return ".buhta.control.v1alpha1.GetOrgResponse";
}

function make$1(org, param) {
  return {
    org: org
  };
}

const $$let = Buhta_controlapis__Buhta_control_v1alpha1_org.Buhta.Control.V1alpha1.Org;

const merge_org = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "org",
    "org"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let.name,
    make: $$let.make,
    from_proto: $$let.from_proto,
    from_proto_exn: $$let.from_proto_exn,
    to_proto: $$let.to_proto,
    to_proto$p: $$let.to_proto$p,
    merge: $$let.merge,
    to_json: $$let.to_json,
    from_json_exn: $$let.from_json_exn,
    from_json: $$let.from_json
  })
]));

function merge$1(t1, t2) {
  return {
    org: Curry._2(merge_org, t1.org, t2.org)
  };
}

function spec$1(param) {
  const $$let = Buhta_controlapis__Buhta_control_v1alpha1_org.Buhta.Control.V1alpha1.Org;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "org",
      "org"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
});

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.org);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(org) {
  return {
    org: org
  };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
});

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$1, writer);
  });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.GetOrgResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.org);
  };
}

function constructor$3(org) {
  return {
    org: org
  };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.GetOrgResponse", spec$1(undefined), constructor$3);
});

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$1, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, GetOrgResponse, {
  make: make$1,
  to_proto: to_proto$1,
  from_proto: from_proto$1,
  to_json: to_json$1,
  from_json: from_json$1,
  name: name$1,
  merge: merge$1,
  to_proto$p: to_proto$p$1,
  from_proto_exn: from_proto_exn$1,
  from_json_exn: from_json_exn$1
});

function name$2(param) {
  return ".buhta.control.v1alpha1.ListOrgsRequest";
}

function make$2(grid, param) {
  return {
    grid: grid
  };
}

const $$let$1 = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;

const merge_grid = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "grid",
    "grid"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$1.name,
    make: $$let$1.make,
    from_proto: $$let$1.from_proto,
    from_proto_exn: $$let$1.from_proto_exn,
    to_proto: $$let$1.to_proto,
    to_proto$p: $$let$1.to_proto$p,
    merge: $$let$1.merge,
    to_json: $$let$1.to_json,
    from_json_exn: $$let$1.from_json_exn,
    from_json: $$let$1.from_json
  })
]));

function merge$2(t1, t2) {
  return {
    grid: Curry._2(merge_grid, t1.grid, t2.grid)
  };
}

function spec$2(param) {
  const $$let = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "grid",
      "grid"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
});

function to_proto$p$2(writer, param) {
  Curry._2(serialize$2, writer, param.grid);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(grid) {
  return {
    grid: grid
  };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
});

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$2, writer);
  });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.ListOrgsRequest", spec$2(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.grid);
  };
}

function constructor$5(grid) {
  return {
    grid: grid
  };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.ListOrgsRequest", spec$2(undefined), constructor$5);
});

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$2, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ListOrgsRequest, {
  make: make$2,
  to_proto: to_proto$2,
  from_proto: from_proto$2,
  to_json: to_json$2,
  from_json: from_json$2,
  name: name$2,
  merge: merge$2,
  to_proto$p: to_proto$p$2,
  from_proto_exn: from_proto_exn$2,
  from_json_exn: from_json_exn$2
});

function name$3(param) {
  return ".buhta.control.v1alpha1.ListOrgsResponse";
}

function make$3(orgsOpt, param) {
  const orgs = orgsOpt !== undefined ? orgsOpt : /* [] */ 0;
  return {
    orgs: orgs
  };
}

const $$let$2 = Buhta_controlapis__Buhta_control_v1alpha1_org.Buhta.Control.V1alpha1.Org;

const merge_orgs = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    1,
    "orgs",
    "orgs"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$2.name,
    make: $$let$2.make,
    from_proto: $$let$2.from_proto,
    from_proto_exn: $$let$2.from_proto_exn,
    to_proto: $$let$2.to_proto,
    to_proto$p: $$let$2.to_proto$p,
    merge: $$let$2.merge,
    to_json: $$let$2.to_json,
    from_json_exn: $$let$2.from_json_exn,
    from_json: $$let$2.from_json
  }),
  Ocaml_protoc_plugin__Spec.not_packed
]));

function merge$3(t1, t2) {
  return {
    orgs: Curry._2(merge_orgs, t1.orgs, t2.orgs)
  };
}

function spec$3(param) {
  const $$let = Buhta_controlapis__Buhta_control_v1alpha1_org.Buhta.Control.V1alpha1.Org;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      1,
      "orgs",
      "orgs"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    }),
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
});

function to_proto$p$3(writer, param) {
  Curry._2(serialize$3, writer, param.orgs);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(orgs) {
  return {
    orgs: orgs
  };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
});

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$3, writer);
  });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.ListOrgsResponse", spec$3(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.orgs);
  };
}

function constructor$7(orgs) {
  return {
    orgs: orgs
  };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.ListOrgsResponse", spec$3(undefined), constructor$7);
});

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$3, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ListOrgsResponse, {
  make: make$3,
  to_proto: to_proto$3,
  from_proto: from_proto$3,
  to_json: to_json$3,
  from_json: from_json$3,
  name: name$3,
  merge: merge$3,
  to_proto$p: to_proto$p$3,
  from_proto_exn: from_proto_exn$3,
  from_json_exn: from_json_exn$3
});

function name$4(param) {
  return ".buhta.control.v1alpha1.LookupOrgRequest";
}

function make$4(countryOpt, tinOpt, param) {
  const country = countryOpt !== undefined ? countryOpt : Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0);
  const tin = tinOpt !== undefined ? tinOpt : "";
  return {
    country: country,
    tin: tin
  };
}

const merge_country = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "country",
    "country"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country),
  Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0)
]));

const merge_tin = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "tin",
    "tin"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

function merge$4(t1, t2) {
  return {
    country: Curry._2(merge_country, t1.country, t2.country),
    tin: Curry._2(merge_tin, t1.tin, t2.tin)
  };
}

function spec$4(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "country",
      "country"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country),
    Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0)
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "tin",
      "tin"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
});

function to_proto$p$4(writer, param) {
  Curry._3(serialize$4, writer, param.country, param.tin);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$4(writer, t);
  return writer;
}

function constructor$8(country, tin) {
  return {
    country: country,
    tin: tin
  };
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
});

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$4, writer);
  });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.LookupOrgRequest", spec$4(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.country, param.tin);
  };
}

function constructor$9(country, tin) {
  return {
    country: country,
    tin: tin
  };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.LookupOrgRequest", spec$4(undefined), constructor$9);
});

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$4, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, LookupOrgRequest, {
  make: make$4,
  to_proto: to_proto$4,
  from_proto: from_proto$4,
  to_json: to_json$4,
  from_json: from_json$4,
  name: name$4,
  merge: merge$4,
  to_proto$p: to_proto$p$4,
  from_proto_exn: from_proto_exn$4,
  from_json_exn: from_json_exn$4
});

function name$5(param) {
  return ".buhta.control.v1alpha1.LookupOrgResponse";
}

function make$5(org, param) {
  return {
    org: org
  };
}

const $$let$3 = Buhta_controlapis__Buhta_control_v1alpha1_org.Buhta.Control.V1alpha1.Org;

const merge_org$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "org",
    "org"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$3.name,
    make: $$let$3.make,
    from_proto: $$let$3.from_proto,
    from_proto_exn: $$let$3.from_proto_exn,
    to_proto: $$let$3.to_proto,
    to_proto$p: $$let$3.to_proto$p,
    merge: $$let$3.merge,
    to_json: $$let$3.to_json,
    from_json_exn: $$let$3.from_json_exn,
    from_json: $$let$3.from_json
  })
]));

function merge$5(t1, t2) {
  return {
    org: Curry._2(merge_org$1, t1.org, t2.org)
  };
}

function spec$5(param) {
  const $$let = Buhta_controlapis__Buhta_control_v1alpha1_org.Buhta.Control.V1alpha1.Org;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "org",
      "org"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$5(undefined));
});

function to_proto$p$5(writer, param) {
  Curry._2(serialize$5, writer, param.org);
}

function to_proto$5(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$5(writer, t);
  return writer;
}

function constructor$10(org) {
  return {
    org: org
  };
}

const from_proto_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$5(undefined), constructor$10);
});

function from_proto$5(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$5, writer);
  });
}

function to_json$5(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.LookupOrgResponse", spec$5(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.org);
  };
}

function constructor$11(org) {
  return {
    org: org
  };
}

const from_json_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.LookupOrgResponse", spec$5(undefined), constructor$11);
});

function from_json$5(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$5, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, LookupOrgResponse, {
  make: make$5,
  to_proto: to_proto$5,
  from_proto: from_proto$5,
  to_json: to_json$5,
  from_json: from_json$5,
  name: name$5,
  merge: merge$5,
  to_proto$p: to_proto$p$5,
  from_proto_exn: from_proto_exn$5,
  from_json_exn: from_json_exn$5
});

function name$6(param) {
  return ".buhta.control.v1alpha1.CreateOrgRequest";
}

function make$6(org, param) {
  return {
    org: org
  };
}

const merge_org$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "org",
    "org"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: OrgData.name,
    make: OrgData.make,
    from_proto: OrgData.from_proto,
    from_proto_exn: OrgData.from_proto_exn,
    to_proto: OrgData.to_proto,
    to_proto$p: OrgData.to_proto$p,
    merge: OrgData.merge,
    to_json: OrgData.to_json,
    from_json_exn: OrgData.from_json_exn,
    from_json: OrgData.from_json
  })
]));

function merge$6(t1, t2) {
  return {
    org: Curry._2(merge_org$2, t1.org, t2.org)
  };
}

function spec$6(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "org",
      "org"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: OrgData.name,
      make: OrgData.make,
      from_proto: OrgData.from_proto,
      from_proto_exn: OrgData.from_proto_exn,
      to_proto: OrgData.to_proto,
      to_proto$p: OrgData.to_proto$p,
      merge: OrgData.merge,
      to_json: OrgData.to_json,
      from_json_exn: OrgData.from_json_exn,
      from_json: OrgData.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$6(undefined));
});

function to_proto$p$6(writer, param) {
  Curry._2(serialize$6, writer, param.org);
}

function to_proto$6(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$6(writer, t);
  return writer;
}

function constructor$12(org) {
  return {
    org: org
  };
}

const from_proto_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$6(undefined), constructor$12);
});

function from_proto$6(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$6, writer);
  });
}

function to_json$6(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.CreateOrgRequest", spec$6(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.org);
  };
}

function constructor$13(org) {
  return {
    org: org
  };
}

const from_json_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.CreateOrgRequest", spec$6(undefined), constructor$13);
});

function from_json$6(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$6, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, CreateOrgRequest, {
  make: make$6,
  to_proto: to_proto$6,
  from_proto: from_proto$6,
  to_json: to_json$6,
  from_json: from_json$6,
  name: name$6,
  merge: merge$6,
  to_proto$p: to_proto$p$6,
  from_proto_exn: from_proto_exn$6,
  from_json_exn: from_json_exn$6
});

function name$7(param) {
  return ".buhta.control.v1alpha1.CreateOrgResponse";
}

function make$7(org, param) {
  return {
    org: org
  };
}

const $$let$4 = Buhta_controlapis__Buhta_control_v1alpha1_org.Buhta.Control.V1alpha1.Org;

const merge_org$3 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "org",
    "org"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$4.name,
    make: $$let$4.make,
    from_proto: $$let$4.from_proto,
    from_proto_exn: $$let$4.from_proto_exn,
    to_proto: $$let$4.to_proto,
    to_proto$p: $$let$4.to_proto$p,
    merge: $$let$4.merge,
    to_json: $$let$4.to_json,
    from_json_exn: $$let$4.from_json_exn,
    from_json: $$let$4.from_json
  })
]));

function merge$7(t1, t2) {
  return {
    org: Curry._2(merge_org$3, t1.org, t2.org)
  };
}

function spec$7(param) {
  const $$let = Buhta_controlapis__Buhta_control_v1alpha1_org.Buhta.Control.V1alpha1.Org;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "org",
      "org"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$7(undefined));
});

function to_proto$p$7(writer, param) {
  Curry._2(serialize$7, writer, param.org);
}

function to_proto$7(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$7(writer, t);
  return writer;
}

function constructor$14(org) {
  return {
    org: org
  };
}

const from_proto_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$7(undefined), constructor$14);
});

function from_proto$7(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$7, writer);
  });
}

function to_json$7(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.CreateOrgResponse", spec$7(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.org);
  };
}

function constructor$15(org) {
  return {
    org: org
  };
}

const from_json_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.CreateOrgResponse", spec$7(undefined), constructor$15);
});

function from_json$7(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$7, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, CreateOrgResponse, {
  make: make$7,
  to_proto: to_proto$7,
  from_proto: from_proto$7,
  to_json: to_json$7,
  from_json: from_json$7,
  name: name$7,
  merge: merge$7,
  to_proto$p: to_proto$p$7,
  from_proto_exn: from_proto_exn$7,
  from_json_exn: from_json_exn$7
});

const BankAccount = Caml_module.init_mod([
  "proto/controlapis/gen/buhta_control_v1alpha1_org_service.ml",
  1786,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name$8(param) {
  return ".buhta.control.v1alpha1.OrgData.BankAccount";
}

function make$8(ibanOpt, bicOpt, open_date, defaultOpt, param) {
  const iban = ibanOpt !== undefined ? ibanOpt : "";
  const bic = bicOpt !== undefined ? bicOpt : "";
  const $$default = defaultOpt !== undefined ? defaultOpt : false;
  return {
    iban: iban,
    bic: bic,
    open_date: open_date,
    default: $$default
  };
}

const merge_iban = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "iban",
    "iban"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_bic = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "bic",
    "bic"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const $$let$5 = Google_type__Google_type_date.Google.Type.$$Date;

const merge_open_date = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    3,
    "open_date",
    "openDate"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$5.name,
    make: $$let$5.make,
    from_proto: $$let$5.from_proto,
    from_proto_exn: $$let$5.from_proto_exn,
    to_proto: $$let$5.to_proto,
    to_proto$p: $$let$5.to_proto$p,
    merge: $$let$5.merge,
    to_json: $$let$5.to_json,
    from_json_exn: $$let$5.from_json_exn,
    from_json: $$let$5.from_json
  })
]));

const merge_default = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    4,
    "default",
    "default"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

function merge$8(t1, t2) {
  return {
    iban: Curry._2(merge_iban, t1.iban, t2.iban),
    bic: Curry._2(merge_bic, t1.bic, t2.bic),
    open_date: Curry._2(merge_open_date, t1.open_date, t2.open_date),
    default: Curry._2(merge_default, t1.default, t2.default)
  };
}

function spec$8(param) {
  const $$let = Google_type__Google_type_date.Google.Type.$$Date;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "iban",
      "iban"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "bic",
      "bic"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      3,
      "open_date",
      "openDate"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      4,
      "default",
      "default"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.nil))));
}

const serialize$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$8(undefined));
});

function to_proto$p$8(writer, param) {
  Curry._5(serialize$8, writer, param.iban, param.bic, param.open_date, param.default);
}

function to_proto$8(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$8(writer, t);
  return writer;
}

function constructor$16(iban, bic, open_date, $$default) {
  return {
    iban: iban,
    bic: bic,
    open_date: open_date,
    default: $$default
  };
}

const from_proto_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$8(undefined), constructor$16);
});

function from_proto$8(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$8, writer);
  });
}

function to_json$8(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.OrgData.BankAccount", spec$8(undefined))(options);
  return function (param) {
    return Curry._4(serialize, param.iban, param.bic, param.open_date, param.default);
  };
}

function constructor$17(iban, bic, open_date, $$default) {
  return {
    iban: iban,
    bic: bic,
    open_date: open_date,
    default: $$default
  };
}

const from_json_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.OrgData.BankAccount", spec$8(undefined), constructor$17);
});

function from_json$8(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$8, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, BankAccount, {
  make: make$8,
  to_proto: to_proto$8,
  from_proto: from_proto$8,
  to_json: to_json$8,
  from_json: from_json$8,
  name: name$8,
  merge: merge$8,
  to_proto$p: to_proto$p$8,
  from_proto_exn: from_proto_exn$8,
  from_json_exn: from_json_exn$8
});

function name$9(param) {
  return ".buhta.control.v1alpha1.OrgData";
}

function make$9(countryOpt, tinOpt, type$pOpt, residentOpt, nameOpt, email, phoneOpt, addressOpt, chief_tinOpt, chief_residentOpt, chief_positionOpt, chief_family_nameOpt, chief_given_nameOpt, chief_patronymic_nameOpt, tax_modeOpt, tax_kogdOpt, tax_vatOpt, tax_vat_percentOpt, tax_vat_seriesOpt, tax_vat_numberOpt, tax_vat_given_date, bank_accountsOpt, param) {
  const country = countryOpt !== undefined ? countryOpt : Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0);
  const tin = tinOpt !== undefined ? tinOpt : "";
  const type$p = type$pOpt !== undefined ? type$pOpt : Curry._1(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType.from_int_exn, 0);
  const resident = residentOpt !== undefined ? residentOpt : false;
  const name = nameOpt !== undefined ? nameOpt : "";
  const phone = phoneOpt !== undefined ? phoneOpt : "";
  const address = addressOpt !== undefined ? addressOpt : "";
  const chief_tin = chief_tinOpt !== undefined ? chief_tinOpt : "";
  const chief_resident = chief_residentOpt !== undefined ? chief_residentOpt : false;
  const chief_position = chief_positionOpt !== undefined ? chief_positionOpt : "";
  const chief_family_name = chief_family_nameOpt !== undefined ? chief_family_nameOpt : "";
  const chief_given_name = chief_given_nameOpt !== undefined ? chief_given_nameOpt : "";
  const chief_patronymic_name = chief_patronymic_nameOpt !== undefined ? chief_patronymic_nameOpt : "";
  const tax_mode = tax_modeOpt !== undefined ? tax_modeOpt : "";
  const tax_kogd = tax_kogdOpt !== undefined ? tax_kogdOpt : "";
  const tax_vat = tax_vatOpt !== undefined ? tax_vatOpt : false;
  const tax_vat_percent = tax_vat_percentOpt !== undefined ? tax_vat_percentOpt : "";
  const tax_vat_series = tax_vat_seriesOpt !== undefined ? tax_vat_seriesOpt : "";
  const tax_vat_number = tax_vat_numberOpt !== undefined ? tax_vat_numberOpt : "";
  const bank_accounts = bank_accountsOpt !== undefined ? bank_accountsOpt : /* [] */ 0;
  return {
    country: country,
    tin: tin,
    "type'": type$p,
    resident: resident,
    name: name,
    email: email,
    phone: phone,
    address: address,
    chief_tin: chief_tin,
    chief_resident: chief_resident,
    chief_position: chief_position,
    chief_family_name: chief_family_name,
    chief_given_name: chief_given_name,
    chief_patronymic_name: chief_patronymic_name,
    tax_mode: tax_mode,
    tax_kogd: tax_kogd,
    tax_vat: tax_vat,
    tax_vat_percent: tax_vat_percent,
    tax_vat_series: tax_vat_series,
    tax_vat_number: tax_vat_number,
    tax_vat_given_date: tax_vat_given_date,
    bank_accounts: bank_accounts
  };
}

const merge_country$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "country",
    "country"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country),
  Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0)
]));

const merge_tin$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "tin",
    "tin"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_type$p = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    3,
    "type",
    "type"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType),
  Curry._1(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType.from_int_exn, 0)
]));

const merge_resident = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    4,
    "resident",
    "resident"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    5,
    "name",
    "name"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_email = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    6,
    "email",
    "email"
  ],
  Ocaml_protoc_plugin__Spec.string
]));

const merge_phone = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    7,
    "phone",
    "phone"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_address = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    8,
    "address",
    "address"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_chief_tin = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    31,
    "chief_tin",
    "chiefTin"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_chief_resident = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    32,
    "chief_resident",
    "chiefResident"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_chief_position = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    33,
    "chief_position",
    "chiefPosition"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_chief_family_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    34,
    "chief_family_name",
    "chiefFamilyName"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_chief_given_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    35,
    "chief_given_name",
    "chiefGivenName"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_chief_patronymic_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    36,
    "chief_patronymic_name",
    "chiefPatronymicName"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_tax_mode = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    51,
    "tax_mode",
    "taxMode"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_tax_kogd = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    52,
    "tax_kogd",
    "taxKogd"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_tax_vat = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    61,
    "tax_vat",
    "taxVat"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_tax_vat_percent = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    62,
    "tax_vat_percent",
    "taxVatPercent"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_tax_vat_series = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    63,
    "tax_vat_series",
    "taxVatSeries"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_tax_vat_number = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    64,
    "tax_vat_number",
    "taxVatNumber"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const $$let$6 = Google_type__Google_type_date.Google.Type.$$Date;

const merge_tax_vat_given_date = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    65,
    "tax_vat_given_date",
    "taxVatGivenDate"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$6.name,
    make: $$let$6.make,
    from_proto: $$let$6.from_proto,
    from_proto_exn: $$let$6.from_proto_exn,
    to_proto: $$let$6.to_proto,
    to_proto$p: $$let$6.to_proto$p,
    merge: $$let$6.merge,
    to_json: $$let$6.to_json,
    from_json_exn: $$let$6.from_json_exn,
    from_json: $$let$6.from_json
  })
]));

const merge_bank_accounts = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    71,
    "bank_accounts",
    "bankAccounts"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: BankAccount.name,
    make: BankAccount.make,
    from_proto: BankAccount.from_proto,
    from_proto_exn: BankAccount.from_proto_exn,
    to_proto: BankAccount.to_proto,
    to_proto$p: BankAccount.to_proto$p,
    merge: BankAccount.merge,
    to_json: BankAccount.to_json,
    from_json_exn: BankAccount.from_json_exn,
    from_json: BankAccount.from_json
  }),
  Ocaml_protoc_plugin__Spec.not_packed
]));

function merge$9(t1, t2) {
  return {
    country: Curry._2(merge_country$1, t1.country, t2.country),
    tin: Curry._2(merge_tin$1, t1.tin, t2.tin),
    "type'": Curry._2(merge_type$p, t1["type'"], t2["type'"]),
    resident: Curry._2(merge_resident, t1.resident, t2.resident),
    name: Curry._2(merge_name, t1.name, t2.name),
    email: Curry._2(merge_email, t1.email, t2.email),
    phone: Curry._2(merge_phone, t1.phone, t2.phone),
    address: Curry._2(merge_address, t1.address, t2.address),
    chief_tin: Curry._2(merge_chief_tin, t1.chief_tin, t2.chief_tin),
    chief_resident: Curry._2(merge_chief_resident, t1.chief_resident, t2.chief_resident),
    chief_position: Curry._2(merge_chief_position, t1.chief_position, t2.chief_position),
    chief_family_name: Curry._2(merge_chief_family_name, t1.chief_family_name, t2.chief_family_name),
    chief_given_name: Curry._2(merge_chief_given_name, t1.chief_given_name, t2.chief_given_name),
    chief_patronymic_name: Curry._2(merge_chief_patronymic_name, t1.chief_patronymic_name, t2.chief_patronymic_name),
    tax_mode: Curry._2(merge_tax_mode, t1.tax_mode, t2.tax_mode),
    tax_kogd: Curry._2(merge_tax_kogd, t1.tax_kogd, t2.tax_kogd),
    tax_vat: Curry._2(merge_tax_vat, t1.tax_vat, t2.tax_vat),
    tax_vat_percent: Curry._2(merge_tax_vat_percent, t1.tax_vat_percent, t2.tax_vat_percent),
    tax_vat_series: Curry._2(merge_tax_vat_series, t1.tax_vat_series, t2.tax_vat_series),
    tax_vat_number: Curry._2(merge_tax_vat_number, t1.tax_vat_number, t2.tax_vat_number),
    tax_vat_given_date: Curry._2(merge_tax_vat_given_date, t1.tax_vat_given_date, t2.tax_vat_given_date),
    bank_accounts: Curry._2(merge_bank_accounts, t1.bank_accounts, t2.bank_accounts)
  };
}

function spec$9(param) {
  const $$let = Google_type__Google_type_date.Google.Type.$$Date;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "country",
      "country"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country),
    Curry._1(Buhta_commonapis__Buhta_common_v1_country.Buhta.Common.V1.Country.from_int_exn, 0)
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "tin",
      "tin"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      3,
      "type",
      "type"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType),
    Curry._1(Buhta_commonapis__Buhta_common_v1_org_type.Buhta.Common.V1.OrgType.from_int_exn, 0)
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      4,
      "resident",
      "resident"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      5,
      "name",
      "name"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      6,
      "email",
      "email"
    ],
    Ocaml_protoc_plugin__Spec.string
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      7,
      "phone",
      "phone"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      8,
      "address",
      "address"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      31,
      "chief_tin",
      "chiefTin"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      32,
      "chief_resident",
      "chiefResident"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      33,
      "chief_position",
      "chiefPosition"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      34,
      "chief_family_name",
      "chiefFamilyName"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      35,
      "chief_given_name",
      "chiefGivenName"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      36,
      "chief_patronymic_name",
      "chiefPatronymicName"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      51,
      "tax_mode",
      "taxMode"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      52,
      "tax_kogd",
      "taxKogd"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      61,
      "tax_vat",
      "taxVat"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      62,
      "tax_vat_percent",
      "taxVatPercent"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      63,
      "tax_vat_series",
      "taxVatSeries"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      64,
      "tax_vat_number",
      "taxVatNumber"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      65,
      "tax_vat_given_date",
      "taxVatGivenDate"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      71,
      "bank_accounts",
      "bankAccounts"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: BankAccount.name,
      make: BankAccount.make,
      from_proto: BankAccount.from_proto,
      from_proto_exn: BankAccount.from_proto_exn,
      to_proto: BankAccount.to_proto,
      to_proto$p: BankAccount.to_proto$p,
      merge: BankAccount.merge,
      to_json: BankAccount.to_json,
      from_json_exn: BankAccount.from_json_exn,
      from_json: BankAccount.from_json
    }),
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.nil))))))))))))))))))))));
}

const serialize$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$9(undefined));
});

function to_proto$p$9(writer, param) {
  Curry.app(serialize$9, [
    writer,
    param.country,
    param.tin,
    param["type'"],
    param.resident,
    param.name,
    param.email,
    param.phone,
    param.address,
    param.chief_tin,
    param.chief_resident,
    param.chief_position,
    param.chief_family_name,
    param.chief_given_name,
    param.chief_patronymic_name,
    param.tax_mode,
    param.tax_kogd,
    param.tax_vat,
    param.tax_vat_percent,
    param.tax_vat_series,
    param.tax_vat_number,
    param.tax_vat_given_date,
    param.bank_accounts
  ]);
}

function to_proto$9(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$9(writer, t);
  return writer;
}

function constructor$18(country, tin, type$p, resident, name, email, phone, address, chief_tin, chief_resident, chief_position, chief_family_name, chief_given_name, chief_patronymic_name, tax_mode, tax_kogd, tax_vat, tax_vat_percent, tax_vat_series, tax_vat_number, tax_vat_given_date, bank_accounts) {
  return {
    country: country,
    tin: tin,
    "type'": type$p,
    resident: resident,
    name: name,
    email: email,
    phone: phone,
    address: address,
    chief_tin: chief_tin,
    chief_resident: chief_resident,
    chief_position: chief_position,
    chief_family_name: chief_family_name,
    chief_given_name: chief_given_name,
    chief_patronymic_name: chief_patronymic_name,
    tax_mode: tax_mode,
    tax_kogd: tax_kogd,
    tax_vat: tax_vat,
    tax_vat_percent: tax_vat_percent,
    tax_vat_series: tax_vat_series,
    tax_vat_number: tax_vat_number,
    tax_vat_given_date: tax_vat_given_date,
    bank_accounts: bank_accounts
  };
}

const from_proto_exn$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$9(undefined), constructor$18);
});

function from_proto$9(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$9, writer);
  });
}

function to_json$9(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.OrgData", spec$9(undefined))(options);
  return function (param) {
    return Curry.app(serialize, [
      param.country,
      param.tin,
      param["type'"],
      param.resident,
      param.name,
      param.email,
      param.phone,
      param.address,
      param.chief_tin,
      param.chief_resident,
      param.chief_position,
      param.chief_family_name,
      param.chief_given_name,
      param.chief_patronymic_name,
      param.tax_mode,
      param.tax_kogd,
      param.tax_vat,
      param.tax_vat_percent,
      param.tax_vat_series,
      param.tax_vat_number,
      param.tax_vat_given_date,
      param.bank_accounts
    ]);
  };
}

function constructor$19(country, tin, type$p, resident, name, email, phone, address, chief_tin, chief_resident, chief_position, chief_family_name, chief_given_name, chief_patronymic_name, tax_mode, tax_kogd, tax_vat, tax_vat_percent, tax_vat_series, tax_vat_number, tax_vat_given_date, bank_accounts) {
  return {
    country: country,
    tin: tin,
    "type'": type$p,
    resident: resident,
    name: name,
    email: email,
    phone: phone,
    address: address,
    chief_tin: chief_tin,
    chief_resident: chief_resident,
    chief_position: chief_position,
    chief_family_name: chief_family_name,
    chief_given_name: chief_given_name,
    chief_patronymic_name: chief_patronymic_name,
    tax_mode: tax_mode,
    tax_kogd: tax_kogd,
    tax_vat: tax_vat,
    tax_vat_percent: tax_vat_percent,
    tax_vat_series: tax_vat_series,
    tax_vat_number: tax_vat_number,
    tax_vat_given_date: tax_vat_given_date,
    bank_accounts: bank_accounts
  };
}

const from_json_exn$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.OrgData", spec$9(undefined), constructor$19);
});

function from_json$9(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$9, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "BankAccount"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, OrgData, {
  BankAccount: BankAccount,
  make: make$9,
  to_proto: to_proto$9,
  from_proto: from_proto$9,
  to_json: to_json$9,
  from_json: from_json$9,
  name: name$9,
  merge: merge$9,
  to_proto$p: to_proto$p$9,
  from_proto_exn: from_proto_exn$9,
  from_json_exn: from_json_exn$9
});

const getOrg_0 = {
  name: GetOrgRequest.name,
  make: GetOrgRequest.make,
  from_proto: GetOrgRequest.from_proto,
  from_proto_exn: GetOrgRequest.from_proto_exn,
  to_proto: GetOrgRequest.to_proto,
  to_proto$p: GetOrgRequest.to_proto$p,
  merge: GetOrgRequest.merge,
  to_json: GetOrgRequest.to_json,
  from_json_exn: GetOrgRequest.from_json_exn,
  from_json: GetOrgRequest.from_json
};

const getOrg_1 = {
  name: GetOrgResponse.name,
  make: GetOrgResponse.make,
  from_proto: GetOrgResponse.from_proto,
  from_proto_exn: GetOrgResponse.from_proto_exn,
  to_proto: GetOrgResponse.to_proto,
  to_proto$p: GetOrgResponse.to_proto$p,
  merge: GetOrgResponse.merge,
  to_json: GetOrgResponse.to_json,
  from_json_exn: GetOrgResponse.from_json_exn,
  from_json: GetOrgResponse.from_json
};

const getOrg = [
  getOrg_0,
  getOrg_1
];

const listOrgs_0 = {
  name: ListOrgsRequest.name,
  make: ListOrgsRequest.make,
  from_proto: ListOrgsRequest.from_proto,
  from_proto_exn: ListOrgsRequest.from_proto_exn,
  to_proto: ListOrgsRequest.to_proto,
  to_proto$p: ListOrgsRequest.to_proto$p,
  merge: ListOrgsRequest.merge,
  to_json: ListOrgsRequest.to_json,
  from_json_exn: ListOrgsRequest.from_json_exn,
  from_json: ListOrgsRequest.from_json
};

const listOrgs_1 = {
  name: ListOrgsResponse.name,
  make: ListOrgsResponse.make,
  from_proto: ListOrgsResponse.from_proto,
  from_proto_exn: ListOrgsResponse.from_proto_exn,
  to_proto: ListOrgsResponse.to_proto,
  to_proto$p: ListOrgsResponse.to_proto$p,
  merge: ListOrgsResponse.merge,
  to_json: ListOrgsResponse.to_json,
  from_json_exn: ListOrgsResponse.from_json_exn,
  from_json: ListOrgsResponse.from_json
};

const listOrgs = [
  listOrgs_0,
  listOrgs_1
];

const lookupOrg_0 = {
  name: LookupOrgRequest.name,
  make: LookupOrgRequest.make,
  from_proto: LookupOrgRequest.from_proto,
  from_proto_exn: LookupOrgRequest.from_proto_exn,
  to_proto: LookupOrgRequest.to_proto,
  to_proto$p: LookupOrgRequest.to_proto$p,
  merge: LookupOrgRequest.merge,
  to_json: LookupOrgRequest.to_json,
  from_json_exn: LookupOrgRequest.from_json_exn,
  from_json: LookupOrgRequest.from_json
};

const lookupOrg_1 = {
  name: LookupOrgResponse.name,
  make: LookupOrgResponse.make,
  from_proto: LookupOrgResponse.from_proto,
  from_proto_exn: LookupOrgResponse.from_proto_exn,
  to_proto: LookupOrgResponse.to_proto,
  to_proto$p: LookupOrgResponse.to_proto$p,
  merge: LookupOrgResponse.merge,
  to_json: LookupOrgResponse.to_json,
  from_json_exn: LookupOrgResponse.from_json_exn,
  from_json: LookupOrgResponse.from_json
};

const lookupOrg = [
  lookupOrg_0,
  lookupOrg_1
];

const createOrg_0 = {
  name: CreateOrgRequest.name,
  make: CreateOrgRequest.make,
  from_proto: CreateOrgRequest.from_proto,
  from_proto_exn: CreateOrgRequest.from_proto_exn,
  to_proto: CreateOrgRequest.to_proto,
  to_proto$p: CreateOrgRequest.to_proto$p,
  merge: CreateOrgRequest.merge,
  to_json: CreateOrgRequest.to_json,
  from_json_exn: CreateOrgRequest.from_json_exn,
  from_json: CreateOrgRequest.from_json
};

const createOrg_1 = {
  name: CreateOrgResponse.name,
  make: CreateOrgResponse.make,
  from_proto: CreateOrgResponse.from_proto,
  from_proto_exn: CreateOrgResponse.from_proto_exn,
  to_proto: CreateOrgResponse.to_proto,
  to_proto$p: CreateOrgResponse.to_proto$p,
  merge: CreateOrgResponse.merge,
  to_json: CreateOrgResponse.to_json,
  from_json_exn: CreateOrgResponse.from_json_exn,
  from_json: CreateOrgResponse.from_json
};

const createOrg = [
  createOrg_0,
  createOrg_1
];

const V1alpha1_OrgService = {
  GetOrg: {
    name: "/buhta.control.v1alpha1.OrgService/GetOrg",
    package_name: "buhta.control.v1alpha1",
    service_name: "OrgService",
    method_name: "GetOrg",
    $$Request: {
      name: GetOrgRequest.name,
      make: GetOrgRequest.make,
      from_proto: GetOrgRequest.from_proto,
      from_proto_exn: GetOrgRequest.from_proto_exn,
      to_proto: GetOrgRequest.to_proto,
      to_proto$p: GetOrgRequest.to_proto$p,
      merge: GetOrgRequest.merge,
      to_json: GetOrgRequest.to_json,
      from_json_exn: GetOrgRequest.from_json_exn,
      from_json: GetOrgRequest.from_json
    },
    $$Response: {
      name: GetOrgResponse.name,
      make: GetOrgResponse.make,
      from_proto: GetOrgResponse.from_proto,
      from_proto_exn: GetOrgResponse.from_proto_exn,
      to_proto: GetOrgResponse.to_proto,
      to_proto$p: GetOrgResponse.to_proto$p,
      merge: GetOrgResponse.merge,
      to_json: GetOrgResponse.to_json,
      from_json_exn: GetOrgResponse.from_json_exn,
      from_json: GetOrgResponse.from_json
    }
  },
  getOrg: getOrg,
  ListOrgs: {
    name: "/buhta.control.v1alpha1.OrgService/ListOrgs",
    package_name: "buhta.control.v1alpha1",
    service_name: "OrgService",
    method_name: "ListOrgs",
    $$Request: {
      name: ListOrgsRequest.name,
      make: ListOrgsRequest.make,
      from_proto: ListOrgsRequest.from_proto,
      from_proto_exn: ListOrgsRequest.from_proto_exn,
      to_proto: ListOrgsRequest.to_proto,
      to_proto$p: ListOrgsRequest.to_proto$p,
      merge: ListOrgsRequest.merge,
      to_json: ListOrgsRequest.to_json,
      from_json_exn: ListOrgsRequest.from_json_exn,
      from_json: ListOrgsRequest.from_json
    },
    $$Response: {
      name: ListOrgsResponse.name,
      make: ListOrgsResponse.make,
      from_proto: ListOrgsResponse.from_proto,
      from_proto_exn: ListOrgsResponse.from_proto_exn,
      to_proto: ListOrgsResponse.to_proto,
      to_proto$p: ListOrgsResponse.to_proto$p,
      merge: ListOrgsResponse.merge,
      to_json: ListOrgsResponse.to_json,
      from_json_exn: ListOrgsResponse.from_json_exn,
      from_json: ListOrgsResponse.from_json
    }
  },
  listOrgs: listOrgs,
  LookupOrg: {
    name: "/buhta.control.v1alpha1.OrgService/LookupOrg",
    package_name: "buhta.control.v1alpha1",
    service_name: "OrgService",
    method_name: "LookupOrg",
    $$Request: {
      name: LookupOrgRequest.name,
      make: LookupOrgRequest.make,
      from_proto: LookupOrgRequest.from_proto,
      from_proto_exn: LookupOrgRequest.from_proto_exn,
      to_proto: LookupOrgRequest.to_proto,
      to_proto$p: LookupOrgRequest.to_proto$p,
      merge: LookupOrgRequest.merge,
      to_json: LookupOrgRequest.to_json,
      from_json_exn: LookupOrgRequest.from_json_exn,
      from_json: LookupOrgRequest.from_json
    },
    $$Response: {
      name: LookupOrgResponse.name,
      make: LookupOrgResponse.make,
      from_proto: LookupOrgResponse.from_proto,
      from_proto_exn: LookupOrgResponse.from_proto_exn,
      to_proto: LookupOrgResponse.to_proto,
      to_proto$p: LookupOrgResponse.to_proto$p,
      merge: LookupOrgResponse.merge,
      to_json: LookupOrgResponse.to_json,
      from_json_exn: LookupOrgResponse.from_json_exn,
      from_json: LookupOrgResponse.from_json
    }
  },
  lookupOrg: lookupOrg,
  CreateOrg: {
    name: "/buhta.control.v1alpha1.OrgService/CreateOrg",
    package_name: "buhta.control.v1alpha1",
    service_name: "OrgService",
    method_name: "CreateOrg",
    $$Request: {
      name: CreateOrgRequest.name,
      make: CreateOrgRequest.make,
      from_proto: CreateOrgRequest.from_proto,
      from_proto_exn: CreateOrgRequest.from_proto_exn,
      to_proto: CreateOrgRequest.to_proto,
      to_proto$p: CreateOrgRequest.to_proto$p,
      merge: CreateOrgRequest.merge,
      to_json: CreateOrgRequest.to_json,
      from_json_exn: CreateOrgRequest.from_json_exn,
      from_json: CreateOrgRequest.from_json
    },
    $$Response: {
      name: CreateOrgResponse.name,
      make: CreateOrgResponse.make,
      from_proto: CreateOrgResponse.from_proto,
      from_proto_exn: CreateOrgResponse.from_proto_exn,
      to_proto: CreateOrgResponse.to_proto,
      to_proto$p: CreateOrgResponse.to_proto$p,
      merge: CreateOrgResponse.merge,
      to_json: CreateOrgResponse.to_json,
      from_json_exn: CreateOrgResponse.from_json_exn,
      from_json: CreateOrgResponse.from_json
    }
  },
  createOrg: createOrg
};

const V1alpha1 = {
  GetOrgRequest: GetOrgRequest,
  GetOrgResponse: GetOrgResponse,
  ListOrgsRequest: ListOrgsRequest,
  ListOrgsResponse: ListOrgsResponse,
  LookupOrgRequest: LookupOrgRequest,
  LookupOrgResponse: LookupOrgResponse,
  CreateOrgRequest: CreateOrgRequest,
  CreateOrgResponse: CreateOrgResponse,
  OrgData: OrgData,
  OrgService: V1alpha1_OrgService
};

const Control = {
  V1alpha1: V1alpha1
};

const Buhta = {
  Control: Control
};

export {
  Imported$pmodules,
  Buhta,
}
/* GetOrgRequest Not a pure module */
